import { urlToBase64 } from  'src/app/utils/common.utils';
import * as moment from "moment-timezone";
import { TitleCasePipe, UpperCasePipe } from '@angular/common';

export async function modivcareReport(
  groupedTripsByDriver: any,
  selectedCorporateObj: any,
  user: any,
  preLevelOfService:any
) {

  const urlBase64 = selectedCorporateObj?.profileImageURL
    ? await urlToBase64(selectedCorporateObj.profileImageURL)
    : "";

  const tableHeader = [
    {
      text: 'Date of\nService',
      bold: true,
      alignment: 'center',
      fillColor: '#d6eeee',
      margin: [0, 10, 0, 10]
    },
    {
      text: 'Trip ID',
      bold: true,
      alignment: 'center',
      fillColor: '#d6eeee',
      margin: [0, 10, 0, 10]
    },
    {
      text: 'Rider',
      bold: true,
      alignment: 'center',
      fillColor: '#d6eeee',
      margin: [0, 10, 0, 10]
    },
    {
      text: 'LOS',
      bold: true,
      alignment: 'center',
      fillColor: '#d6eeee',
      margin: [0, 10, 0, 10]
    },
    {
      text: 'Pick-up\nTime',
      bold: true,
      alignment: 'center',
      fillColor: '#d6eeee',
      margin: [0, 10, 0, 10]
    },
    {
      text: 'Drop-Off\nTime',
      bold: true,
      alignment: 'center',
      fillColor: '#d6eeee',
      margin: [0, 10, 0, 10]
    },
    {
      text: 'Total Trip\nMileage',
      bold: true,
      alignment: 'center',
      fillColor: '#d6eeee',
      margin: [0, 10, 0, 10]
    },
    {
      text: 'Per Trip\nBilled\nAmount',
      bold: true,
      alignment: 'center',
      fillColor: '#d6eeee',
      margin: [0, 10, 0, 10]
    },
    {
      text: 'Rider Signature',
      bold: true,
      alignment: 'center',
      fillColor: '#d6eeee',
      margin: [0, 10, 0, 10]
    }
  ];

  const tableLayout = {
    hLineWidth: () => 1,
    vLineWidth: () => 1,
    hLineColor: () => '#000000',
    vLineColor: () => '#000000',
    paddingLeft: () => 4,
    paddingRight: () => 4
  };

  const buildProviderInfo = (group: any) => ({
  margin: [0, 20, 0, 20],
  table: {
    widths: ['45%', '10%', '45%'],
    body: [
      [
        {
          text: user?.name?.toUpperCase() || '',
          border: [false, false, false, true]
        },
        { text: '', border: [false, false, false, false] },
        {
          text: moment().format('MM/DD/YYYY hh:mm A'),
          border: [false, false, false, true]
        }
      ],
      [
        {
          text: 'Provider Name',
          bold: true,
          fontSize: 8,
          border: [false, false, false, false],
          margin: [0, 2, 0, 0]
        },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] }
      ],
      [
        {
          text: group.driver?.displayName?.toUpperCase() || '',
          border: [false, false, false, true],
          margin: [0, 15, 0, 0]
        },
        { text: '', border: [false, false, false, false] },
        {
          text: group.trips?.[0]?.vehicle?.vin || '',
          border: [false, false, false, true],
          margin: [0, 15, 0, 0]
        }
      ],
      [
        {
          text: 'Driver Name',
          bold: true,
          fontSize: 8,
          border: [false, false, false, false],
          margin: [0, 2, 0, 0]
        },
        { text: '', border: [false, false, false, false] },
        {
          text: 'Vehicle Identification Number',
          bold: true,
          fontSize: 8,
          border: [false, false, false, false],
          margin: [0, 2, 0, 0]
        }
      ]
    ]
  }
});

  const buildTripsTable = (trips: any[]) => ({
    table: {
      headerRows: 1,
      dontBreakRows: true,
      keepWithHeaderRows: 1,
      widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
      body: [
        tableHeader.map(h => ({ ...h })), 
        ...trips.map((trip: any) => ([
          {
            text: moment(trip.pickup?.time).format('MM/DD/YYYY'),
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
          {
            text: `${trip.reference || ''}-${trip.suffix || ''}`,
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
          {
            text: `${trip.member?.lastName || ''}, ${trip.member?.firstName || ''}`.toUpperCase(),
            margin: [0, 5, 0, 5]
          },
          {
            text: preLevelOfService && preLevelOfService[trip.levelOfService] ? preLevelOfService[trip.levelOfService].title : '',
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
          {
            text: moment(trip.pickup?.time).format('HH:mm'),
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
          {
            text: moment(trip.destination?.time).format('HH:mm'),
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
          {
            text: trip.miles || 0,
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
          {
            text: `$${Number(trip.fare?.breakdown?.total || 0).toFixed(2)}`,
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
        signatureMap[trip.id]
  ? {
      image: signatureMap[trip.id],
      width: 100,
      height: 60,
      alignment: 'center',
      margin: [0, 5, 0, 5]
    }
  : {
      text: '',
      italics: true,
      margin: [0, 5, 0, 5]
    }
        ]))
      ]
    },
    layout: tableLayout
  });

  // Preload trip signatures
const signatureMap: Record<string, string> = {};

const allTrips = Object.values(groupedTripsByDriver || {})
  .flatMap((group: any) => group?.trips || []);

await Promise.all(
  allTrips.map(async (trip: any) => {
    if (trip?.signature) {
      try {
        signatureMap[trip.id] = await urlToBase64(trip.signature);
      } catch (e) {
        signatureMap[trip.id] = '';
      }
    }
  })
);

  const content: any[] = [];

  Object.values(groupedTripsByDriver || {}).forEach((group: any, index: number) => {
    if (!group?.driver || !group?.trips?.length) return;

    if (index > 0) {
      content.push({ text: '', pageBreak: 'before' });
    }

    content.push(
  buildProviderInfo(group),   // ⬅️ REQUIRED (this was missing visually)
  buildTripsTable(group.trips)
);
  });

  return {
    pageSize: 'A4',
    pageOrientation: 'portrait',

    // IMPORTANT (space for header)
    pageMargins: [40, 110, 40, 80],

    defaultStyle: {
      fontSize: 9,
      color: '#000000'
    },

    content,

    // ✅ FIX #1: TITLE + LOGO ON EVERY PAGE
   header: function () {
  return {
    columns: [
      {
        image: urlBase64,
        width: 90,
        height: 55
      },
      {
        text: 'ADVANCED TRANSPORTATION MANAGEMENT SYSTEM',
        bold: true,
        fontSize: 13,
        alignment: 'right',
        margin: [0, 20, 40, 0]
      }
    ],
    margin: [40, 20, 40, 0]
  };
},

    footer: (currentPage: number, pageCount: number) => ({
      margin: [40, 10, 40, 0],
      stack: [
        {
          text: 'DRIVER SIGNATURE:     NO DRIVER SIGNATURE FOUND',
          bold: true,
          fontSize: 10,
          alignment: 'center',
          margin: [0, 0, 0, 20]
        },
        {
          columns: [
            {
              text: 'Copyright(c) 2013-2025 Modivcare Solutions, LLC. All rights Reserved.',
              fontSize: 8,
              alignment: 'left'
            },
            {
              text: `Page ${currentPage} of ${pageCount}`,
              fontSize: 8,
              alignment: 'right'
            }
          ]
        }
      ]
    })
  };
}
